import type { UserSessionData } from '../../contexts/AuthContext';
import { useAuthContext } from '../../contexts/useAuthContext';

const canUserImpersonate = (isSuperUser: boolean, userData: UserSessionData | null | undefined) => {
  const hasIamSuperuserRole = userData?.user.roles?.some((r) => r.value === 'superuser') ?? false;
  return isSuperUser || hasIamSuperuserRole;
};

export const useCanImpersonate = () => {
  const { isSuperUser, userData } = useAuthContext();
  return canUserImpersonate(isSuperUser, userData);
};
